import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['modal']
  static values = { id: String }

  connect() {
    this.modalTarget.addEventListener('click', this.handleModalClick.bind(this))
    this.uuid = this.modalTarget.dataset.uuid

    const modalDismissed = sessionStorage.getItem(`flash-modal-${this.idValue}`)
    if (!modalDismissed) {
      this.showModal()
    }
  }

  disconnect() {
    this.modalTarget.removeEventListener('click', this.handleModalClick.bind(this))
    this.modalTarget.remove()
  }

  showModal() {
	this.modal = new bootstrap.Modal(this.modalTarget)
    this.modal.show();
  }

  closeModal() {
    if (this.modal) {
      sessionStorage.setItem(`flash-modal-${this.idValue}`, 'true')
      this.modal.hide();
    }
  }

  handleLinkClick(event) {
    this.closeModal();
  }

  handleModalClick(event) {
    if (event.target.tagName === 'A' && event.target.href) {
      this.closeModal();
    }
  }
}
